"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import Select from "react-select";

const AddPurchase = () => {
  const [formData, setFormData] = useState({
    product_master_code: '',
    product_name: '',
    category_name: '',
    product_unit: '',
    product_color: '',
    quantity_purchased: '',
    purchase_price_per_unit: '',
    Date: new Date().toISOString().split('T')[0] // Set default to today's date
  })

  const [categories, setCategories] = useState([])
  const [units, setUnits] = useState([])
  const [colors, setColors] = useState([])
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    fetchCategories()
    fetchUnits()
    fetchColors()
    fetchProducts()
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-categories`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setCategories(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch categories")
    }
  }

  const fetchUnits = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-units`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setUnits(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch units")
    }
  }

  const fetchColors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-colors`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setColors(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch colors")
    }
  }

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-products`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setProducts(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch products")
    } finally {
      setIsLoading(false)
    }
  }

  // const handleProductSelect = (e) => {
  //   const selectedProduct = products.find(p => p.product_code === e.target.value)
  //   if (selectedProduct) {
  //     setFormData({
  //       ...formData,
  //       product_master_code: selectedProduct.product_code,
  //       product_name: selectedProduct.product_name,
  //       category_name: selectedProduct.category_name,
  //       product_unit: selectedProduct.product_unit
  //     })
  //   } else {
  //     setFormData({
  //       ...formData,
  //       product_master_code: '',
  //       product_name: '',
  //       category_name: '',
  //       product_unit: ''
  //     })
  //   }
  // }
  // ✅ Updated handleProductSelect to support react-select
  const handleProductSelect = (selectedOption) => {  // Highlighted new function argument
    const selectedProduct = products.find(p => p.product_code === selectedOption?.value)
    if (selectedProduct) {
      setFormData({
        ...formData,
        product_master_code: selectedProduct.product_code,
        product_name: selectedProduct.product_name,
        category_name: selectedProduct.category_name,
        product_unit: selectedProduct.product_unit
      })
    } else {
      setFormData({
        ...formData,
        product_master_code: '',
        product_name: '',
        category_name: '',
        product_unit: '',
        
      })
    }
    
  }
  
   const handlePriceSet = async (color) => {
   

   if(color!='' && formData.product_master_code!=''){
   color=color.replace(/\s+/g, '')
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/last-price/${formData.product_master_code}/${color}`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data) {
        
        setFormData(prev=>({
        ...prev,
        purchase_price_per_unit: response.data.details.purchase_price_per_unit
        }))
        setError(null)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to auto set price, set manually")
      setFormData(prev=>({
        ...prev,
        purchase_price_per_unit: ''
        }))
    }
  }else{
    setFormData(prev=>({
        ...prev,
        purchase_price_per_unit: ''
        }))
  }
  }
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev=>({
        ...prev,
      [name]: value
    }))
    console.log(name,value, formData.product_color, formData.product_master_code)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError(null)
    setSuccess(false)

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/add-purchased-product`,
        formData,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data) {
        setFormData({
          product_master_code: '',
          product_name: '',
          category_name: '',
          product_unit: '',
          product_color: '',
          quantity_purchased: '',
          purchase_price_per_unit: '',
          date: new Date().toISOString().split('T')[0]
        })
        setSuccess(true)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add purchase")
    } finally {
      setIsSubmitting(false)
    }
  }
  const productOptions = products.map((product) => ({
    value: product.product_code,
    label: `${product.product_code} - ${product.product_name}`,
  }));
  const colorOptions = colors.map((color) => ({
    value: color.product_color,
    label: color.product_color,
  }));

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">Add Purchase</h1>

          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
              Purchase added successfully!
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Code
                </label>

                {/* <select
                  name="product_master_code"
                  value={formData.product_master_code}
                  onChange={handleProductSelect}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  disabled={isSubmitting}
                >
                  <option value="">Select Product</option>
                  {products.map((product) => (
                    <option key={product.id} value={product.product_code}>
                      {product.product_code} - {product.product_name}
                    </option>
                  ))}
                </select> */}

                <Select
                  name="product_master_code"
                  options={productOptions}
                  value={productOptions.find(
                    (option) => option.value === formData.product_master_code
                  ) || null}
                  onChange={(selectedOption)=>{handleProductSelect(selectedOption); handlePriceSet(formData.product_color)}}
                  isDisabled={isSubmitting}
                  placeholder="Search/Select Product"
                  isClearable={true}
                  className="w-full"
                  classNamePrefix="react-select"
                />
              </div>




              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Name
                </label>
                <input
                  type="text"
                  name="product_name"
                  value={formData.product_name}
                  readOnly
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Category
                </label>
                <input
                  type="text"
                  name="category_name"
                  value={formData.category_name}
                  readOnly
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Unit
                </label>
                <input
                  type="text"
                  name="product_unit"
                  value={formData.product_unit}
                  readOnly
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Color
                </label>
                {/* <select
                  id="product_color"
                  name="product_color"
                  value={formData.product_color}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  disabled={isSubmitting}
                >
                  <option value="">Select Color</option>
                  {colors.map((color) => (
                    <option key={color.id} value={color.product_color}>
                      {color.product_color}
                    </option>
                  ))}
                </select> */}
                <Select
                  name="product_color"
                  options={colorOptions}
                  value={colorOptions.find(
                    (option) => option.value === formData.product_color
                  ) || null}
                  onChange={(selectedOption) =>{
                    
                    handleChange({
                      target: { name: "product_color", value: selectedOption?.value || "" }
                    }); handlePriceSet(selectedOption?.value || "")
                  }}
                  isDisabled={isSubmitting}
                  placeholder="Select color"
                  isClearable={true}
                  className="w-full"
                  classNamePrefix="react-select"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Quantity
                </label>
                <input
                  type="number"
                  name="quantity_purchased"
                  value={formData.quantity_purchased}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  min="0"
                  disabled={isSubmitting}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Price Per Unit
                </label>
                <input
                  type="number"
                  name="purchase_price_per_unit"
                  value={formData.purchase_price_per_unit}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  min="0"
                  step="0.01"
                  disabled={isSubmitting}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Purchase Date
                </label>
                <input
                  type="date"
                  name="Date"
                  value={formData.Date}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={() => window.location.href = '/all-purchases'}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Adding..." : "Add Purchase"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddPurchase
